import {createAsyncThunk} from "@reduxjs/toolkit";
import {changeTokenSuccess} from "../core.slice";
import Axios from "axios";
import {SitePreferences, TokenRecord} from "@commons/mapping/TokenRecord";
import {config} from "@commons/config.instance";
import {cambiaDominio, cambiaDominioEAzienda} from "@commons/services/aziende/aziende.api";

//https://blog.logrocket.com/async-await-in-typescript/

function changePeriodoService(url: string, token: string, data: { anno: number, mese: number }): Promise<TokenRecord> {

    const api = `${url}/${token}/periodo`;
    return Axios.put<TokenRecord>(api, data)
        .then(res => {
            return res.data;
        })
}

function changePreferencesService(url: string, token: string, data: SitePreferences): Promise<TokenRecord> {

    const api = `${url}/${token}/site-preferences`;
    return Axios.put<TokenRecord>(api, data)
        .then(res => {
            return res.data;
        })
}

const changeDomainService = cambiaDominio;

export const changeDomain = createAsyncThunk<TokenRecord, number>(
    'auth/change/domain',
    async (idDominio, {dispatch, rejectWithValue}) => {
        try {
            const tokenResult = await changeDomainService(idDominio);
            dispatch(changeTokenSuccess(tokenResult));
            return tokenResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)

export const changeDomainPlusAzienda = createAsyncThunk<TokenRecord, { idDominio: number, idAzienda: number }>(
    'auth/change/domainPlusAzienda',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const tokenResult = await cambiaDominioEAzienda(payload);
            dispatch(changeTokenSuccess(tokenResult));
            return tokenResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)

export const changePeriodo = createAsyncThunk<TokenRecord, { token: string, anno: number, mese: number }>(
    'auth/change/periodo',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const tokenResult = await changePeriodoService(config.getBaseUrl('FPNet') + '/tabella/sessione', payload.token, {anno: payload.anno, mese: payload.mese});
            dispatch(changeTokenSuccess(tokenResult));
            return tokenResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)

export const updateSitePreferences = createAsyncThunk<TokenRecord, { token: string, pref: SitePreferences }>(
    'auth/change/preference',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const tokenResult = await changePreferencesService(config.getBaseUrl('FPNet') + '/tabella/sessione', payload.token, payload.pref);
            dispatch(changeTokenSuccess(tokenResult));
            return tokenResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)

export function changeOrderService(idOrder: number): Promise<TokenRecord> {

    const url = config.getBaseUrl('FPNet') + `/access/domain/current/sortOrder/${idOrder}`;
    return Axios.put<TokenRecord>(url, {})
        .then(res => {
            return res.data;
        });
}

export const changeOrder = createAsyncThunk<TokenRecord, number>(
    'auth/change/aziendaOrder',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const tokenResult = await changeOrderService(payload);
            dispatch(changeTokenSuccess(tokenResult));
            return tokenResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)